import React, { Component } from 'react';
import i18n from 'utils/translate';

const defaultProps = {
  linkClassName: '',
  onLocationClick: () => {}
};

class UserLocationFiltering extends Component {
  render() {
    return (
      <a
        href="#"
        role="button"
        className={this.props.linkClassName}
        onClick={e => {
          e.preventDefault();
          this.props.onLocationClick();
        }}
      >
        <i className="icon-pin"></i>&nbsp;
        {i18n('find-closest')}
      </a>
    );
  }
}

UserLocationFiltering.defaultProps = defaultProps;

export default UserLocationFiltering;
